var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

// src/utilities/Type.ts
var isArray = (value) => {
  return Array.isArray(value);
};
var isNullOrUndefined = (value) => {
  return value == null || typeof value === "undefined" /* UNDEFINED */;
};
var isNumber = (value) => {
  if (isNaN(value))
    return false;
  return typeof value === "number" /* NUMBER */ && isFinite(value);
};

// src/module/Metric.ts
var _state, _config, _previousCountTotaled, _previousCountAveraged, _defaultState, _defineState, _setState, _resolve, _calculateTotal, _calculateAverage, _formatValues, _roundingFormatter, _now;
var Metric = class {
  constructor(incomingState) {
    __privateAdd(this, _state, void 0);
    __privateAdd(this, _config, void 0);
    __privateAdd(this, _previousCountTotaled, 0);
    __privateAdd(this, _previousCountAveraged, 0);
    __privateAdd(this, _defaultState, () => {
      return {
        key: "Default Metric Key",
        count: 0,
        recorded: []
      };
    });
    __privateAdd(this, _defineState, (incomingState = {}) => {
      return Object.assign(
        {},
        __privateGet(this, _defaultState).call(this),
        __privateGet(this, _state) || {},
        incomingState
      );
    });
    __privateAdd(this, _setState, (incomingState) => {
      __privateSet(this, _state, __privateGet(this, _defineState).call(this, incomingState));
    });
    __publicField(this, "report", (reportConfig) => {
      let reportedValues = {
        average: this.average,
        count: this.count,
        mostRecent: this.mostRecent,
        recorded: this.recorded,
        total: this.total
      };
      if (!isNullOrUndefined(reportConfig)) {
        let formatter = void 0;
        if (!!(reportConfig == null ? void 0 : reportConfig.roundValues)) {
          formatter = __privateGet(this, _roundingFormatter);
        }
        if (!isNullOrUndefined(formatter)) {
          reportedValues = __privateGet(this, _formatValues).call(this, reportedValues, formatter);
        }
      }
      return reportedValues;
    });
    __publicField(this, "start", (incomingState) => {
      var _a, _b, _c;
      if (!isNullOrUndefined(incomingState)) {
        __privateGet(this, _setState).call(this, incomingState);
      }
      __privateGet(this, _state).inProgress = __privateGet(this, _state).inProgress || __privateGet(this, _now).call(this, (_a = __privateGet(this, _config)) == null ? void 0 : _a.preferDate);
      if (!isNullOrUndefined(__privateGet(this, _state).onStart)) {
        (_c = (_b = __privateGet(this, _state)).onStart) == null ? void 0 : _c.call(_b, {
          value: __privateGet(this, _state).inProgress,
          metric: this.state
        });
      }
    });
    __publicField(this, "end", (incomingState) => {
      var _a, _b;
      if (!isNullOrUndefined(incomingState)) {
        __privateGet(this, _setState).call(this, incomingState);
      }
      const result = __privateGet(this, _resolve).call(this);
      if (isNullOrUndefined(result) || !result) {
        return;
      }
      if (!__privateGet(this, _state).recorded) {
        __privateGet(this, _state).recorded = [];
      }
      __privateGet(this, _state).recorded.push(result);
      __privateGet(this, _state).mostRecent = result;
      __privateGet(this, _state).count = (__privateGet(this, _state).count || 0) + 1;
      if (!isNullOrUndefined(__privateGet(this, _state).onEnd)) {
        (_b = (_a = __privateGet(this, _state)).onEnd) == null ? void 0 : _b.call(_a, {
          value: result,
          metric: this.state
        });
      }
    });
    __privateAdd(this, _resolve, () => {
      var _a;
      if (isNullOrUndefined(__privateGet(this, _state).inProgress)) {
        return void 0;
      }
      let result = __privateGet(this, _now).call(this, (_a = __privateGet(this, _config)) == null ? void 0 : _a.preferDate) - __privateGet(this, _state).inProgress;
      if (!result || result < 0) {
        console.warn("Measure - measurement result was invalid (", result, "), defaulting to 1ms.");
        result = 1;
      }
      __privateGet(this, _state).inProgress = void 0;
      return result;
    });
    __privateAdd(this, _calculateTotal, () => {
      if (__privateGet(this, _state).recorded && Array.isArray(__privateGet(this, _state).recorded)) {
        let total = 0;
        __privateGet(this, _state).recorded.forEach((recordItem) => {
          total += recordItem;
        });
        __privateGet(this, _state).total = total;
      }
      return __privateGet(this, _state).total;
    });
    __privateAdd(this, _calculateAverage, () => {
      if (__privateGet(this, _state).count && this.total) {
        __privateGet(this, _state).average = this.total / __privateGet(this, _state).count;
      }
      return __privateGet(this, _state).average;
    });
    __privateAdd(this, _formatValues, (rawReport, formatter) => {
      let formatted = Object.assign({}, rawReport);
      if (isNullOrUndefined(formatted)) {
        return;
      }
      Object.keys(formatted).forEach((reportValueKey) => {
        if (isArray(formatted[reportValueKey])) {
          formatted[reportValueKey] = formatted[reportValueKey].map(formatter);
        } else {
          formatted[reportValueKey] = formatter(formatted[reportValueKey]);
        }
      });
      return formatted;
    });
    __privateAdd(this, _roundingFormatter, (value) => {
      if (!isNumber(value)) {
        return value;
      }
      const decimalPoints = 2;
      const decimalCoefficient = Math.pow(10, decimalPoints);
      return Math.round(value * decimalCoefficient) / decimalCoefficient;
    });
    __privateAdd(this, _now, (preferDate = false) => {
      if (!!(performance == null ? void 0 : performance.now) && !preferDate) {
        return performance.now();
      }
      return Date.now();
    });
    __privateSet(this, _config, incomingState || {});
    __privateGet(this, _setState).call(this, __privateGet(this, _config));
  }
  get key() {
    var _a;
    return (_a = __privateGet(this, _state)) == null ? void 0 : _a.key;
  }
  get average() {
    var _a;
    if (__privateGet(this, _state).count !== __privateGet(this, _previousCountAveraged)) {
      __privateSet(this, _previousCountAveraged, __privateGet(this, _state).count);
      __privateGet(this, _calculateAverage).call(this);
    }
    return (_a = __privateGet(this, _state)) == null ? void 0 : _a.average;
  }
  get count() {
    var _a;
    return (_a = __privateGet(this, _state)) == null ? void 0 : _a.count;
  }
  get inProgress() {
    var _a;
    return (_a = __privateGet(this, _state)) == null ? void 0 : _a.inProgress;
  }
  get mostRecent() {
    var _a;
    return (_a = __privateGet(this, _state)) == null ? void 0 : _a.mostRecent;
  }
  get recorded() {
    var _a;
    return (_a = __privateGet(this, _state)) == null ? void 0 : _a.recorded;
  }
  get total() {
    var _a;
    if (__privateGet(this, _state).count !== __privateGet(this, _previousCountTotaled)) {
      __privateSet(this, _previousCountTotaled, __privateGet(this, _state).count);
      __privateGet(this, _calculateTotal).call(this);
    }
    return (_a = __privateGet(this, _state)) == null ? void 0 : _a.total;
  }
  get state() {
    return {
      key: this.key,
      average: this.average,
      count: this.count,
      inProgress: this.inProgress,
      mostRecent: this.mostRecent,
      recorded: this.recorded,
      total: this.total
    };
  }
};
_state = new WeakMap();
_config = new WeakMap();
_previousCountTotaled = new WeakMap();
_previousCountAveraged = new WeakMap();
_defaultState = new WeakMap();
_defineState = new WeakMap();
_setState = new WeakMap();
_resolve = new WeakMap();
_calculateTotal = new WeakMap();
_calculateAverage = new WeakMap();
_formatValues = new WeakMap();
_roundingFormatter = new WeakMap();
_now = new WeakMap();

// src/module/Measure.ts
var __instance, _instance, instance_get, _initializeMetric;
var _Measure = class _Measure {
  constructor() {
    __publicField(this, "metrics");
    /**
     * Instance Methods
     */
    __publicField(this, "start", (key, config) => {
      if (isNullOrUndefined(this.metrics[key])) {
        this.metrics[key] = __privateGet(this, _initializeMetric).call(this, key, config);
      }
      this.metrics[key].start();
    });
    __privateAdd(this, _initializeMetric, (key, config = {}) => {
      return new Metric({
        key,
        ...config
      });
    });
    __publicField(this, "end", (key, config) => {
      if (isNullOrUndefined(this.metrics[key])) {
        console.warn("Measure - Attempted to end a measurement for Metric", key, "which has not yet been started");
        return;
      }
      this.metrics[key].end(config);
    });
    __publicField(this, "report", (config) => {
      let dataSet = {
        averages: {},
        counts: {},
        mostRecent: {},
        recorded: {},
        totals: {}
      };
      Object.keys(this.metrics).forEach((key) => {
        let report = this.metrics[key].report(config);
        dataSet.averages[key] = report.average;
        dataSet.counts[key] = report.count;
        dataSet.mostRecent[key] = report.mostRecent;
        dataSet.recorded[key] = report.recorded;
        dataSet.totals[key] = report.total;
      });
      return dataSet;
    });
    this.metrics = {};
  }
  static get metrics() {
    let metrics = __privateGet(_Measure, _instance, instance_get).metrics;
    let result = {};
    Object.keys(metrics).forEach((key) => {
      result[key] = metrics[key].state;
    });
    return result;
  }
};
__instance = new WeakMap();
_instance = new WeakSet();
instance_get = function() {
  if (!__privateGet(_Measure, __instance)) {
    __privateSet(_Measure, __instance, new _Measure());
  }
  return __privateGet(_Measure, __instance);
};
_initializeMetric = new WeakMap();
__privateAdd(_Measure, _instance);
__privateAdd(_Measure, __instance, void 0);
/**
 * External API
 */
/**
 * Begins a measurement under the provided key
 * @param {string} key
 * @param {IMetricConfig} config
 */
__publicField(_Measure, "start", (key, config) => {
  __privateGet(_Measure, _instance, instance_get).start(key, config);
});
/**
 * Ends the measurement associated with the provided key
 * @param {string} key
 * @param {IMetricConfig} config
 */
__publicField(_Measure, "end", (key, config) => {
  __privateGet(_Measure, _instance, instance_get).end(key, config);
});
/**
 * Ends the first measurement and begins the second.  Shortcut for a common pattern of
 * end(firstMeasurement) ... start(secondMeasurement).
 * @param {string} endingKey
 * @param {string} startingKey
 * @param {IMetricConfig} config
 */
__publicField(_Measure, "checkpoint", (endingKey, startingKey, config) => {
  __privateGet(_Measure, _instance, instance_get).end(endingKey, config);
  __privateGet(_Measure, _instance, instance_get).start(startingKey, config);
});
/**
 * Returns a report package, containing several data banks that can be used for
 * manual inspection, or piped into other services (Sentry, Newrelic, etc).
 * @returns {IMeasureReport}
 */
__publicField(_Measure, "report", (config) => {
  return __privateGet(_Measure, _instance, instance_get).report(config);
});
var Measure = _Measure;
export {
  Measure
};
